import { analyticsConstants } from "../../constants/ActionTypes";
import { baseUrl } from '../../constants/baseUrl';

export const getCustomerRecencyDayAction = (paramObj, onSuccess, onFailure) => ({
    type: analyticsConstants.GET_CUSTOMER_RECENCY_DAY,
    payload: paramObj,
    meta: {
        type: 'apijson', //use apijson for returning json objects, and api for returning strings
        url: baseUrl + '/customer_recency',
        onSuccess: onSuccess,
        onFailure: onFailure,
        params: {
            shop_id: paramObj.shopId,
            date_first: paramObj.dateFirst,
            date_second: paramObj.dateSecond
        },
        options: {
            method: 'GET'
        }
    }
})